import React, { useRef } from 'react';
import Select from 'react-select';
import { useTheme } from '@material-ui/core/styles';
import { Layout } from '../../configs/ui/constant';

const dot = (color = '#ccc') => ({
   alignItems: 'center',
   display: 'flex',

   ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 8,
      height: 10,
      width: 10,
   },
});
const SelectMultiAll = (props) => {
   const theme = useTheme();

   const {
      isLoading,
      placeholder,
      isDisabled,
      defaultValue,
      name,
      title,
      alert,
      onMenuOpen,
      colourStyles,
      defaultInputValue,
      inputValue,
   } = props;

   const valueRef = useRef(props.value);
   valueRef.current = props.value;

   const selectAllOption = {
      value: '<SELECT_ALL>',
      label: 'เลือกทั้งหมด',
   };

   const isSelectAllSelected = () =>
      valueRef.current.length === props.options.length;

   const isOptionSelected = (option) =>
      valueRef.current.some(({ value }) => value === option.value) ||
      isSelectAllSelected();

   const getOptions = () => [selectAllOption, ...props.options];

   const getValue = () =>
      isSelectAllSelected() ? [selectAllOption] : props.value;

   const onChange = (newValue, actionMeta) => {
      const { action, option, removedValue } = actionMeta;

      if (
         action === 'select-option' &&
         option.value === selectAllOption.value
      ) {
         props.onChange(props.options, actionMeta);
      } else if (
         (action === 'deselect-option' &&
            option.value === selectAllOption.value) ||
         (action === 'remove-value' &&
            removedValue.value === selectAllOption.value)
      ) {
         props.onChange([], actionMeta);
      } else if (
         actionMeta.action === 'deselect-option' &&
         isSelectAllSelected()
      ) {
         props.onChange(
            props.options.filter(({ value }) => value !== option.value),
            actionMeta,
         );
      } else {
         props.onChange(newValue || [], actionMeta);
      }
   };
   const customStyles = {
      input: (base) => ({
         ...base,
         fontFamily: `'DBHeavent', sans-serif `,
         '& input': {
            font: 'inherit',
         },
      }),
      control: (base, state) => ({
         ...base,
         borderRadius: '5px',
         boxShadow: '',
         fontFamily: `'DBHeavent', sans-serif `,
         // minHeight: '2.2rem',
         '&:focus': {
            border: '1.25px solid',
            borderColor: Layout.primary,
            boxShadow: '',
         },
         '&:hover': {
            border: '1.25px solid',
            borderColor: state.isFocused ? Layout.primary : Layout.primary,
            boxShadow: '',
         },
         border: alert ? '1.25px solid red' : '1.25px solid #d3d2d1',
      }),
      menu: (base) => ({
         ...base,
         backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#FFFFFF',
         // borderRadius: "5px",
      }),
      menuList: (base) => ({
         ...base,
      }),
      singleValue: (base) => ({
         ...base,
      }),
      indicatorSeparator: (base) => ({
         ...base,
         display: 'none',
      }),
      dropdownIndicator: (base) => ({
         ...base,
      }),
      placeholder: (base) => ({
         ...base,
      }),
      container: (base) => ({
         ...base,
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 999999,
      }),
   };
   const mycolourStyles = {
      control: (base, state) => ({
         ...base,
         borderRadius: '5px',
         boxShadow: '',
         // minHeight: '2.2rem',
         '&:focus': {
            border: '1.25px solid',
            borderColor: Layout.primary,
            boxShadow: '',
         },
         '&:hover': {
            border: '1.25px solid',
            borderColor: state.isFocused ? Layout.primary : Layout.primary,
            boxShadow: '',
         },
         border: alert ? '1.25px solid red' : '1.25px solid #d3d2d1',
      }),
      input: (styles) => ({ ...styles, ...dot() }),
      menu: (base) => ({
         ...base,
         backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#FFFFFF',
         // borderRadius: "5px",
      }),
      placeholder: (styles) => ({ ...styles, ...dot() }),
      singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
      indicatorSeparator: (base) => ({
         ...base,
         display: 'none',
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 999999,
      }),
   };
   return (
      <React.Fragment>
         <Select
            name={name}
            id={title}
            options={getOptions()}
            onChange={onChange}
            value={getValue()}
            styles={colourStyles ? mycolourStyles : customStyles}
            defaultValue={defaultValue && defaultValue}
            defaultInputValue={defaultInputValue && defaultInputValue}
            inputValue={inputValue && inputValue}
            placeholder={placeholder}
            isLoading={isLoading}
            isDisabled={isDisabled}
            isOptionSelected={isOptionSelected}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            menuPortalTarget={document.querySelector('body')}
            onMenuOpen={onMenuOpen}
            isClearable
            // inputProps={{readOnly:true}}
         />
      </React.Fragment>
   );
};

export default SelectMultiAll;
